// src/templates/public-portal/variants/GroceryPortal.tsx
import React, { useState, useEffect, useMemo } from 'react';
import { Service, Company, Product, Bundle, API_BS_URL} from '../../../services/api';
import {
  User, FileText,  Package, CheckCircle2, Sparkles, Tag, Clock, HeartHandshake, Menu, Lock, ArrowRight, ArrowLeft, ArrowUpRight, Layers, Settings, Utensils, Briefcase, PhoneCall, Heart, ChevronDown, ShoppingBag, ChevronLeft, ChevronRight, Play,Plus, Trash2,
  CheckCircle, Info, CreditCard, UtensilsCrossed, ShoppingCart, X,
  Search, Calendar, Minus, Check, User2, Eye,
  Zap,MapPin, ArrowUpDown, Globe, Headphones, Truck,
  Linkedin,
  Instagram,
  Facebook,
  Leaf,
  Target,
  ShieldCheck,
  Star,
  Quote,
  Mail,
  Smartphone
} from 'lucide-react';
import toast from 'react-hot-toast';
import { api } from '../../../services/api';

const SERVER_BASE_URL = import.meta.env.VITE_API_BS_URL || 'http://localhost:5000';

// Helper function to convert relative paths to absolute URLs
const getImageUrl = (imagePath: string): string => {
  if (!imagePath) return '';
  if (imagePath.startsWith('http')) return imagePath; // Already absolute
  return `${SERVER_BASE_URL}${imagePath}`; // Convert relative to absolute
};

interface GroceryProps {
  company: Company;
  slug: string;
  services: Service[];
  products?: Product[];
  bundles?: Bundle[];
  portalContent?: any;
  selectedLocation?: string;
}

type CatalogType = 'services' | 'products' | 'bundles';

type CartItem = {
  itemId: string;
  type: CatalogType;
  quantity: number;
  name: string;
  price: number;
  image?: string;
  madeToOrder?: boolean;
  orderPrice?: number;
  deliveryDays?: number;
  wantsOrder?: boolean;
};

interface ClientInfo {
  name: string;
  contactPerson: string;
  email: string;
  phone: string;
  taxId: string;
  vatNumber?: string;
  billingAddress: {
    street: string;
    city: string;
    country: string;
  };
}

const GroceryPortal: React.FC<GroceryProps> = ({ 
  company, 
  slug, 
  services: initialServices,
  products: initialProducts,
  bundles: initialBundles,
  selectedLocation = "Maputo",
  setSelectedLocation,
  portalContent = {
    hero: {
    headline: "Logística & Infraestrutura Global",
    subheadline: "Gestão Integrada de Frotas, Transporte de Cargas e Soluções de Armazenamento de Alta Performance",
    backgroundImage: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&q=80&w=2000"
  },
   about: {
    enabled: true,
    title: "Conectando Mercados com Eficiência e Precisão Cirúrgica",
    body: "<p>Somos líderes em soluções logísticas ponta a ponta. Com uma infraestrutura moderna e tecnologia de rastreamento em tempo real, garantimos a segurança e a agilidade na movimentação das suas cargas em todo o território nacional e internacional.</p>",
    image: "https://images.unsplash.com/photo-1578575437130-527eed3abbec?auto=format&fit=crop&q=80&w=1000"
  },
   missionVision: {
    enabled: true,
    mission: { 
      title: "Nossa Missão", 
      content: "Proporcionar soluções de transporte e logística integradas com máxima eficiência, redução de custos operacionais e pontualidade rigorosa para a sua cadeia de suprimentos." 
    },
    vision: { 
      title: "Nossa Visão", 
      content: "Ser a referência global em logística inteligente e sustentável, impulsionando o comércio por meio de tecnologia avançada de gestão de frota." 
    },
    values: { 
      title: "Nossos Valores", 
      items: [
        "Pontualidade Absoluta", 
        "Segurança & Rastreabilidade", 
        "Transparência Operacional", 
        "Inovação em Supply Chain"
      ] 
    }
  },
    clients: { enabled: true, items: [] },
    testimonials: { enabled: true, items: [] }
  },
}) => {
  const [cart, setCart] = useState<CartItem[]>([]);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeCatalog, setActiveCatalog] = useState<CatalogType>('services');
  const [searchTerm, setSearchTerm] = useState('');
  const [services, setServices] = useState<Service[]>(initialServices || []);

  // will calculate available catalogs once services/products/bundles are defined later

  // track searches performed by visitors (debounced so we don't spam the API)
   // logging de pesquisa já não depende de activeCatalog
  useEffect(() => {
    if (!searchTerm || !slug) return;
   const handler = setTimeout(async () => {
  try {
    await api.public.logSearch(slug, { term: searchTerm, catalog: 'all' });
    console.log(`✅ Pesquisa registrada: "${searchTerm}"`);
  } catch (err) {
    console.error('❌ Falha ao registrar busca:', err);
  }
}, 500);
    return () => clearTimeout(handler);
  }, [searchTerm, slug]);

  const [products, setProducts] = useState<Product[]>(initialProducts || []);
  const [bundles, setBundles] = useState<Bundle[]>(initialBundles || []);

  // compute which catalogs currently have items
  const availableCatalogs: CatalogType[] = React.useMemo(() => {
    const list: CatalogType[] = [];
    if (services && services.length > 0) list.push('services');
    if (products && products.length > 0) list.push('products');
    if (bundles && bundles.length > 0) list.push('bundles');
    return list;
  }, [services, products, bundles]);

 useEffect(() => {
  console.log("Company data received:", {
    hasBankAccounts: !!company?.bankAccounts?.length,
    hasMobileWallets: !!company?.mobileWallets,
    bankAccounts: company?.bankAccounts,
    mobileWallets: company?.mobileWallets
  });
}, [company]);

  // ensure activeCatalog is always one of the available ones when data changes
  useEffect(() => {
    if (availableCatalogs.length === 0) return;
    if (!availableCatalogs.includes(activeCatalog)) {
      setActiveCatalog(availableCatalogs[0]);
    }
  }, [availableCatalogs, activeCatalog]);

  const [submitting, setSubmitting] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any | null>(null);
  const [carouselIndex, setCarouselIndex] = useState(0);
  const [isSearchOpen, setIsSearchOpen] = useState(false);


  const [client, setClient] = useState<ClientInfo>({
    name: '',
    contactPerson: '',
    email: '',
    phone: '',
    taxId: '',
    vatNumber: '',
    billingAddress: { street: '', city: '', country: 'Moçambique' }
  });

  const [requestedInstallments, setRequestedInstallments] = useState(1);
  const [deliveryDate, setDeliveryDate] = useState('');
  const [requestIntent, setRequestIntent] = useState<'quotation' | 'invoice'>('quotation');
  const [notes, setNotes] = useState('');
  const [paymentMethod, setPaymentMethod] = useState<'mpesa'|'emola'|'visa'|'transfer'|'none'>('none');
  const [mobileMoneyPhone, setMobileMoneyPhone] = useState('');
  const [showAwaitingConfirmation, setShowAwaitingConfirmation] = useState(false);
  const [awaitingRef, setAwaitingRef] = useState<string>('');
  const [pollStatus, setPollStatus] = useState<'waiting'|'confirmed'|'failed'>('waiting');
  const [pollAttempts, setPollAttempts] = useState(0);
const [visibleServices, setVisibleServices] = useState(3);
const [currentImgIndex, setCurrentImgIndex] = useState(0);
  const currency = company.currency || 'MT';

    // ------------ alterações -------------
  // controla o “ver mais” de cada secção
  const [showAllProducts, setShowAllProducts] = useState(false);


  // guarda o tipo do item que está aberto no modal (usado mais abaixo)
  const [selectedItemType, setSelectedItemType] = useState<CatalogType | null>(null);

  const openItem = (item: any, type: CatalogType) => {
    setSelectedItem(item);
    setSelectedItemType(type);
    setCarouselIndex(0);
  };

    // listas filtradas individualmente
  const filteredProducts = products.filter(item =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (item.description?.toLowerCase().includes(searchTerm.toLowerCase()))
  );
  const filteredServices = services.filter(item =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (item.description?.toLowerCase().includes(searchTerm.toLowerCase()))
  );
  const filteredBundles = bundles.filter(item =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (item.description?.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (item.shortDescription?.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  // Only load if initial data is not provided (public portal provides all data)
 useEffect(() => {
  if (initialServices?.length && initialProducts?.length && initialBundles?.length) {
    return;
  }
  
  const loadCatalog = async () => {
    try {
      const promises = [];
      if (!initialServices?.length) promises.push(api.services.getAll());
      if (!initialProducts?.length) promises.push(api.products.getAll());
      if (!initialBundles?.length) promises.push(api.bundles.getAll());
      
      if (promises.length === 0) return;
      
      const results = await Promise.all(promises);
      console.log("Produtos vindos da API:", results[1]);
      // LOGS DE DEPURAÇÃO
      console.log("--- Resposta Bruta da API ---");
      console.log("Serviços:", results[0]);
      console.log("Produtos:", results[1]);
      console.log("Bundles (Combos/Subs):", results[2]);
      
      // Verifica se os campos esperados existem dentro do primeiro bundle (se houver)
      if (results[2] && results[2].length > 0) {
        console.log("Estrutura do primeiro Bundle:", results[2][0]);
        console.log("Itens populados?", results[2][0].items);
      }

      if (!initialServices?.length && results[0]) setServices(results[0]);
      if (!initialProducts?.length && results[1]) setProducts(results[1]);
      if (!initialBundles?.length && results[2]) setBundles(results[2]);
      
    } catch (err) {
      console.error('Erro detalhado ao carregar catálogo:', err);
    }
  };
  loadCatalog();
}, []);
  // Reset carousel index whenever a new item is selected
  useEffect(() => {
    setCarouselIndex(0);
  }, [selectedItem]);

 const total = useMemo(() => {
  const subtotal = cart.reduce((acc, item) => acc + (item.price * item.quantity), 0);
  
  // Calculamos quanto custa apenas as taxas de encomenda (se houver)
  const orderFeesTotal = cart.reduce((acc, item) => {
    if (item.wantsOrder && item.orderPrice) {
      return acc + (Number(item.orderPrice) * item.quantity);
    }
    return acc;
  }, 0);

  // Se houver qualquer item com taxa de encomenda ativa, o Grand Total vira apenas o valor das taxas
  // Caso contrário, é o subtotal normal.
  const isPayingFees = cart.some(item => item.wantsOrder && Number(item.orderPrice) > 0);
  const grandTotal = isPayingFees ? orderFeesTotal : subtotal;

  return { subtotal, orderFeesTotal, grandTotal, isPayingFees };
}, [cart]);



  // Image helper (products & bundles have real images, services use placeholder – add image field to Service later)
  const getItemImage = (item: any, type: CatalogType): string | undefined => {
    // Products and bundles keep previous logic. For services, prefer real images from DB if available.
    if (type === 'products' && item.images?.length > 0) return getImageUrl(item.images[0]);
    if (type === 'bundles' && item.image) return getImageUrl(item.image);
    if (type === 'services' && item.images?.length > 0) return getImageUrl(item.images[0]);
    return undefined;
  };

  const getItemPrice = (item: any): number => {
  if (!item) return 0;

  const price = 
    item.billingPricePerCycle ?? 
    item.basePrice ?? 
    item.price ?? 
    0;

  // Debug opcional (remove depois de testar)
  // console.log(`getItemPrice for "${item.name}" (type: ${item.type || 'unknown'}):`, price);

  return Number(price);
};

  function getItemDescription(item: any): string {
    return 'shortDescription' in item ? (item as any).shortDescription || '' :
      ('description' in item ? (item as any).description || '' : '');
  }

  const getServicePriceLabel = (s: any): string => {
    if (!s) return 'Sob consulta';
    const sPrice = (s.showPrice !== false && s.basePrice)
      ? `${s.basePrice.toFixed(2)} ${currency}`
      : null;
    const sRange = (s.minPrice || s.maxPrice)
      ? `${(s.minPrice || 0).toFixed(2)} – ${(s.maxPrice || 0).toFixed(2)} ${currency}`
      : null;
    return sPrice || sRange || 'Sob consulta';
  };

  const getBundlePriceLabel = (b: any): string => {
    if (!b) return 'Sob consulta';
    if (b.type === 'Subscription') return b.price ? `${b.price.toLocaleString()} ${currency}` : 'Grátis';
    const bPrice = (b.showPrice !== false && b.price)
      ? `${b.price.toLocaleString()} ${currency}`
      : null;
    const bRange = (b.minPrice || b.maxPrice)
      ? `${(b.minPrice || 0).toLocaleString()} – ${(b.maxPrice || 0).toLocaleString()} ${currency}`
      : null;
    return bPrice || bRange || 'Sob consulta';
  };

  // Cart actions
const addToCart = (item: any, type: CatalogType) => {
  // Proteção contra stock zero (exceto madeToOrder)
  if (item.stockQuantity <= 0 && !item.madeToOrder) {
    toast.error(`Produto ${item.name} sem stock disponível`);
    return;
  }

  const existingIndex = cart.findIndex(c => c.itemId === item._id);

  if (existingIndex !== -1) {
    const updated = [...cart];
    updated[existingIndex].quantity += 1;
    setCart(updated);
  } else {
    setCart([...cart, {
      itemId: item._id,
      type,
      quantity: 1,
      name: item.name,
      price: getItemPrice(item),
      image: getItemImage(item, type),

      // === CAMPOS CRUCIAIS PARA MADE TO ORDER ===
      madeToOrder: item.madeToOrder, 
    orderPrice: item.orderPrice,
    deliveryDays: item.deliveryDays,
      wantsOrder: false,                          // começa desmarcado
    }]);
  }

  toast.success(`${item.name} adicionado ao carrinho`, { position: 'top-center' });
};

   const hasOrderWithPrice = cart.some(item => 
  item.wantsOrder === true && Number(item.orderPrice || 0) > 0
);

  const updateCartQuantity = (itemId: string, newQty: number) => {
    if (newQty < 1) return;
    setCart(cart.map(item => item.itemId === itemId ? { ...item, quantity: newQty } : item));
  };

  const removeFromCart = (itemId: string) => {
    setCart(cart.filter(item => item.itemId !== itemId));
  };

  // Totals (exactly your original logic)
  const calculateTotals = () => {
    let subtotal = 0;
    let minAllowed = 99;
    let maxPenaltyPct = 0;

    cart.forEach(cartItem => {
      subtotal += cartItem.price * cartItem.quantity;
      const svc = services.find(s => s._id === cartItem.itemId);
      if (svc) {
        minAllowed = Math.min(minAllowed, svc.allowedInstallments || 3);
        maxPenaltyPct = Math.max(maxPenaltyPct, svc.penaltyPercentagePerInstallment || 0);
      }
    });

    let penalty = 0;
    if (requestedInstallments > minAllowed) {
      const extra = requestedInstallments - minAllowed;
      penalty = subtotal * (extra * (maxPenaltyPct / 100));
    }

    return { subtotal, penalty, grandTotal: subtotal + penalty };
  };

  const totals = calculateTotals();

  // Dynamic max installments (your original logic)
  const getMaxAllowedInstallments = (): number => {
    let minAllowed = Infinity;
    let hasService = false;
    cart.forEach(cartItem => {
      const svc = services.find(s => s._id === cartItem.itemId);
      if (svc) {
        hasService = true;
        minAllowed = Math.min(minAllowed, svc.allowedInstallments || 3);
      }
    });
    return hasService ? Math.max(1, minAllowed) : 12;
  };

  const hasValidItems = cart.length > 0;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!hasValidItems) {
      toast.error('Adicione pelo menos um item ao carrinho');
      return;
    }
    if (!client.name || !client.email) {
      toast.error('Nome da empresa e email são obrigatórios');
      return;
    }

    setSubmitting(true);

    try {
     // Dentro de handleSubmit, substitui o payload por:
      const payload = {
        companyId: company._id,
        clientData: { ...client, origin: 'external' },
        requisitionData: {
          items: cart.map(cartItem => ({
            itemType: cartItem.type === 'services' ? 'service' : 
                      cartItem.type === 'products' ? 'product' : 'bundle',
            item: cartItem.itemId,
            isMadeToOrder: cartItem.wantsOrder,
            priceAtOrder: cartItem.price,
            feePaid: cartItem.wantsOrder ? cartItem.orderPrice : 0,
            quantity: cartItem.quantity
          })),
          paymentMethod,
          totalAmount: total.subtotal,
          amountPaid: total.isPayingFees ? total.orderFeesTotal : 0,
          requestedInstallments,
          deliveryDate,
          requestIntent,
          notes
        }
      };

      await api.requisitions.submitPublic(payload);

      setShowSuccessModal(true);
      toast.success('Requisição enviada com sucesso!');

      // Reset everything
      setCart([]);
      setClient({
        name: '', contactPerson: '', email: '', phone: '', taxId: '', vatNumber: '',
        billingAddress: { street: '', city: '', country: 'Moçambique' }
      });
      setRequestedInstallments(1);
      setDeliveryDate('');
      setRequestIntent('quotation');
      setNotes('');
      setIsCartOpen(false);
    } catch (err: any) {
      toast.error(err.message || 'Falha ao enviar');
    } finally {
      setSubmitting(false);
    }
  };
useEffect(() => {
  if (selectedItem?.items) {
    console.log("ESTRUTURA FINAL NO FRONTEND:", JSON.stringify(selectedItem.items, null, 2));
  }
}, [selectedItem]);
 const handlePayment = async () => {
  if (!paymentMethod || paymentMethod === 'none') {
    toast.error('Selecione um método de pagamento');
    return;
  }
  if (!hasValidItems) {
    toast.error('Adicione pelo menos um item ao carrinho');
    return;
  }
  if (!client.name || !client.email) {
    toast.error('Preencha o nome e email para processar o pagamento');
    return;
  }

  // Mobile money prefix validation
  if (paymentMethod === 'mpesa' || paymentMethod === 'emola') {
    if (!mobileMoneyPhone) {
      toast.error(`Número de ${paymentMethod === 'mpesa' ? 'M-Pesa' : 'E-Mola'} é obrigatório`);
      return;
    }
    const cleaned = mobileMoneyPhone.replace(/\D/g, '');
    const isMpesa = paymentMethod === 'mpesa';
    const isEmola = paymentMethod === 'emola';
    const validMpesa = cleaned.startsWith('84') || cleaned.startsWith('85');
    const validEmola = cleaned.startsWith('86') || cleaned.startsWith('87');
    if (isMpesa && !validMpesa) {
      toast.error('Número M-Pesa deve começar com 84 ou 85');
      return;
    }
    if (isEmola && !validEmola) {
      toast.error('Número E-Mola deve começar com 86 ou 87');
      return;
    }
  }

  setSubmitting(true);
  try {
    const effectivePhone = (paymentMethod === 'mpesa' || paymentMethod === 'emola')
      ? mobileMoneyPhone : client.phone;
    const payload = {
      totalAmount: totals.grandTotal,
      method: paymentMethod,
      customer: {
        name: client.name,
        phone: effectivePhone,
        email: client.email,
      },
      companyId: company._id,
      currency: currency,
      items: cart.map(ci => ({
        itemId: ci.itemId,
        name: ci.name,
        quantity: ci.quantity,
        price: ci.price,
        type: ci.type
      }))
    };
    const resp = await api.checkout.process(payload, true);
    console.log('✅ Resposta do checkout:', resp);
    if (resp?.success) {
      if (resp.awaiting_confirmation || (resp.status === 'pending' && (paymentMethod === 'mpesa' || paymentMethod === 'emola'))) {
        setAwaitingRef(resp.externalRef);
        setPollStatus('waiting');
        setPollAttempts(0);
        setShowAwaitingConfirmation(true);
        return;
      }
      if (resp.url) {
        window.location.href = resp.url;
      } else {
        toast.success(resp.message || 'Pagamento processado com sucesso!');
        setTimeout(() => {
          window.location.href = `/order-success?ref=${resp.externalRef}`;
        }, 1500);
      }
    } else {
      toast.error(resp?.message || 'Não foi possível iniciar o pagamento');
    }
  } catch (err: any) {
    console.error('Payment error:', err);
    if (err.message?.includes('504') || err.response?.status === 504) {
      toast.error('O serviço de pagamento está demorando muito. Tente novamente.');
    } else {
      toast.error(err.message || 'Erro ao processar pagamento');
    }
  } finally {
    setSubmitting(false);
  }
};

    // Poll awaiting confirmation
  useEffect(() => {
    if (!showAwaitingConfirmation || !awaitingRef) return;
    let cancelled = false;
    setPollStatus('waiting');
    setPollAttempts(0);

    const interval = setInterval(async () => {
      try {
        const res = await api.checkout.transactionStatus(awaitingRef);
        if (cancelled) return;
        if (res?.found && res.transaction) {
          if (res.transaction.status === 'success') {
            setPollStatus('confirmed');
            clearInterval(interval);
            setTimeout(() => {
              setShowAwaitingConfirmation(false);
              setShowSuccessModal(true);
            }, 1500);
            return;
          } else if (res.transaction.status === 'failed') {
            setPollStatus('failed');
            clearInterval(interval);
            setTimeout(() => setShowAwaitingConfirmation(false), 3000);
            return;
          }
        } else if (res?.status === 'success' || res?.status === 'completed') {
          setPollStatus('confirmed');
          clearInterval(interval);
          setTimeout(() => {
            window.location.href = `/order-success?ref=${awaitingRef}`;
          }, 2000);
          return;
        } else if (res?.status === 'failed' || res?.status === 'cancelled') {
          setPollStatus('failed');
          clearInterval(interval);
          return;
        }
        setPollAttempts(p => p + 1);
      } catch {}
    }, 3000);
    return () => { cancelled = true; clearInterval(interval); };
  }, [showAwaitingConfirmation, awaitingRef]);

  const closeSuccessModal = () => setShowSuccessModal(false);

  return (
    <div className="min-h-screen bg-[#f8f7f2] text-[#1a1a1a] font-sans overflow-x-hidden">
    {/* 1. TOP ANNOUNCEMENT BAR */}
      <div className="w-full bg-[#053B29] py-2 px-4 text-center text-[11px] md:text-xs font-medium text-white/90 flex items-center justify-center gap-2">
        <span>{portalContent?.announcement || "Get 20% OFF your first order"}</span>
        <span className="text-emerald-400 font-bold">•</span>
        <span className="text-emerald-300 font-semibold">
          Order now and get it delivered within <span className="underline">30 minutes</span>
        </span>
      </div>

      {/* MAIN CONTAINER WRAPPER */}
      <div className="max-w-7xl mx-auto px-3 sm:px-6 py-3">
        
        {/* 2. MAIN HEADER (Fast & Objective UX) */}
        <header className="bg-white rounded-2xl shadow-sm border border-slate-100 p-3 md:p-4 mb-4">
          <div className="flex items-center justify-between gap-3 md:gap-6">
            
            {/* Logo */}
            <div className="flex items-center shrink-0">
              {company.logo ? (
                <img src={company.logo} alt={company.name} className="h-8 md:h-10 w-auto object-contain" />
              ) : (
                <span className="font-extrabold text-2xl md:text-3xl text-[#053B29] tracking-tight flex items-center gap-1">
                  {company.name || "TazajMart"}
                  <span className="w-2 h-2 rounded-full bg-amber-400 inline-block"></span>
                </span>
              )}
            </div>

            

            {/* User Actions: Cart & Profile */}
            <div className="flex items-center gap-2 md:gap-3 shrink-0">
              {/* User Account */}
              <button 
                className="hidden sm:flex items-center justify-center p-2.5 bg-slate-100 hover:bg-slate-200 rounded-full text-slate-700 transition-colors"
                aria-label="Account"
              >
                <User size={18} />
              </button>

              {/* Shopping Cart Button */}
              <button
                onClick={() => setIsCartOpen(true)}
                className="relative flex items-center gap-2 px-3.5 py-2 bg-[#053B29] hover:bg-[#042f21] text-white rounded-full transition-all shadow-sm"
              >
                <ShoppingBag size={18} />
                <span className="hidden sm:inline text-xs font-bold">Cart</span>
                {cart.length > 0 && (
                  <span className="bg-amber-400 text-slate-950 text-[10px] font-black w-5 h-5 rounded-full flex items-center justify-center ml-0.5">
                    {cart.length}
                  </span>
                )}
              </button>

              {/* Mobile Menu Toggle */}
              <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="lg:hidden p-2 text-slate-700 hover:bg-slate-100 rounded-lg transition-colors"
              >
                {isMobileMenuOpen ? <X size={22} /> : <Menu size={22} />}
              </button>
            </div>
          </div>


          {/* MOBILE DRAWER */}
          {isMobileMenuOpen && (
            <div className="lg:hidden mt-3 pt-3 border-t border-slate-100 flex flex-col gap-2 text-sm font-medium">
              <div className="flex items-center gap-2 px-3 py-2 bg-slate-100 rounded-xl mb-2 text-xs">
                <MapPin size={16} className="text-[#053B29]" />
                <span>Delivery to: <strong className="text-slate-900">{selectedLocation}</strong></span>
              </div>
              <a href="#products" className="py-2 px-3 hover:bg-slate-50 rounded-lg">Products</a>
              <a href="#whats-new" className="py-2 px-3 hover:bg-slate-50 rounded-lg">Whats new</a>
              <a href="#deals" className="py-2 px-3 text-emerald-700 font-bold hover:bg-slate-50 rounded-lg">Deals & Offers</a>
              <a href="#support" className="py-2 px-3 hover:bg-slate-50 rounded-lg">Help & Support</a>
            </div>
          )}
        </header>

       {/* 3. HERO BANNER (Modern Grocery Centered Layout) */}
<section className="relative rounded-[24px] md:rounded-[32px] overflow-hidden min-h-[420px] md:min-h-[500px] shadow-xl flex items-center justify-center p-6 sm:p-10 md:p-16">
  
  {/* Background Image Container */}
  <div className="absolute inset-0 z-0">
    <img 
      src={getImageUrl(portalContent?.hero?.backgroundImage) || "https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&q=80"} 
      alt="Fresh Groceries Background" 
      className="w-full h-full object-cover object-center"
    />
    {/* Dark Gradient Overlay para legibilidade perfeita do texto */}
    <div className="absolute inset-0 bg-gradient-to-t from-[#053B29]/95 via-[#053B29]/80 to-[#053B29]/65" />
  </div>

  {/* Background Decorative Pattern */}
  <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#fff_1px,transparent_1px)] [background-size:16px_16px] pointer-events-none z-0" />

  {/* Centered Content Wrapper */}
  <div className="relative z-10 w-full max-w-3xl mx-auto text-center flex flex-col items-center space-y-6">
    
    {/* Badge Promocional Opcional */}
    {portalContent?.hero?.badge && (
      <span className="px-4 py-1.5 rounded-full bg-white/10 backdrop-blur-md border border-white/20 text-amber-300 text-xs font-semibold tracking-wide">
        {portalContent.hero.badge}
      </span>
    )}

    {/* Centered Headline */}
    <h1 className="text-3xl sm:text-5xl md:text-6xl font-extrabold text-white leading-[1.15] tracking-tight">
      {portalContent?.hero?.headline || (
        <>
          Get <span className="text-amber-400">free delivery</span> on shopping $200
        </>
      )}
    </h1>

    {/* Centered Subheadline */}
    <p className="text-emerald-100/90 text-xs sm:text-sm md:text-base max-w-xl leading-relaxed font-normal">
      {portalContent?.hero?.subheadline || 
        "Get the freshest groceries delivered right to your home. Save time, skip the lines, and enjoy quick, efficient delivery."}
    </p>

    {/* SEARCH & LOCATION BAR (Unificados no Centro) */}
    <div className="w-full max-w-2xl pt-2">
      <div className="bg-white/95 backdrop-blur-md p-1.5 sm:p-2 rounded-2xl sm:rounded-full shadow-2xl border border-white/30 flex flex-col sm:flex-row items-center gap-2">
        
        {/* Seletor de Localização */}
        <div className="w-full sm:w-auto flex items-center justify-between sm:justify-start gap-2 px-4 py-2 bg-slate-100 hover:bg-slate-200/80 rounded-xl sm:rounded-full transition-colors cursor-pointer shrink-0 text-xs border border-slate-200/50">
          <div className="flex items-center gap-2">
            <MapPin size={16} className="text-[#053B29] shrink-0" />
            <div className="flex flex-col text-left">
              <span className="text-[9px] text-slate-500 font-medium leading-none uppercase tracking-wider">Deliver to</span>
              <span className="font-bold text-slate-900 leading-tight flex items-center gap-1">
                {selectedLocation || "Maputo"}
              </span>
            </div>
          </div>
          <ChevronDown size={14} className="text-slate-500" />
        </div>

        {/* Separador Visual (apenas Desktop) */}
        <div className="hidden sm:block h-6 w-[1px] bg-slate-300/60" />

        {/* Campo de Pesquisa */}
        <div className="relative flex-1 w-full flex items-center">
          <Search size={18} className="absolute left-3.5 text-slate-400 pointer-events-none" />
          <input
            type="text"
            placeholder="Search fresh groceries, categories, brands..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full bg-transparent text-slate-900 text-xs md:text-sm pl-10 pr-9 py-2.5 rounded-full border border-transparent outline-none placeholder:text-slate-400 font-medium"
          />
          {searchTerm && (
            <button 
              onClick={() => setSearchTerm('')}
              className="absolute right-3 text-slate-400 hover:text-slate-600 p-1"
            >
              <X size={16} />
            </button>
          )}
        </div>

        {/* Botão de Ação / Search CTA */}
        <button className="w-full sm:w-auto px-6 py-3 bg-[#053B29] hover:bg-[#03281c] text-amber-400 font-bold text-xs md:text-sm rounded-xl sm:rounded-full transition-all flex items-center justify-center gap-2 shrink-0 shadow-md">
          <span>Search</span>
          <ArrowRight size={16} />
        </button>

      </div>
    </div>

    {/* CTA Secundário / Link Opcional */}
    {portalContent?.hero?.ctaText && (
      <div className="pt-2">
        <a 
          href="#shop-now"
          className="inline-flex items-center gap-2 text-xs font-semibold text-amber-300 hover:text-amber-200 underline underline-offset-4 transition-colors"
        >
          <span>{portalContent.hero.ctaText}</span>
          <ArrowRight size={12} />
        </a>
      </div>
    )}

  </div>
</section>

      </div>

{/* PRODUCTS SECTION (Grocery Centered Layout) */}
{filteredProducts.length > 0 && (
  <section className="py-12 md:py-16 bg-slate-50 text-slate-900 relative overflow-hidden">
    
    {/* Subtle Grocery Grid Background */}
    <div 
      className="absolute inset-0 opacity-[0.02] pointer-events-none" 
      style={{
        backgroundImage: 'radial-gradient(#053B29 1.5px, transparent 1.5px)', 
        backgroundSize: '20px 20px'
      }} 
    />

    <div className="max-w-7xl mx-auto px-4 md:px-8 relative z-10">
      
      {/* Header Block with Title & Category Filter */}
      <div className="mb-8 md:mb-10 flex flex-col gap-5">
        
        {/* Section Title */}
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-2xl md:text-3xl font-extrabold text-[#053B29] tracking-tight">
              Todos os Produtos
            </h2>
            <p className="text-xs md:text-sm text-slate-500 font-medium mt-1">
              Produtos frescos e de qualidade entregues à sua porta.
            </p>
          </div>
        </div>

        {/* Category Filter Bar */}
        <div className="flex items-center gap-2 md:gap-3 pb-2 overflow-x-auto scrollbar-hide">
          <button className="px-5 py-2 bg-[#053B29] text-white rounded-full text-xs font-bold whitespace-nowrap transition-all shadow-sm shrink-0">
            Todos os produtos
          </button>
          {['Legumes', 'Congelados', 'Laticínios', 'Carnes', 'Bebidas'].map((category) => (
            <button
              key={category}
              className="px-5 py-2 bg-white border border-slate-200 text-slate-700 rounded-full text-xs font-semibold whitespace-nowrap hover:border-[#053B29] hover:text-[#053B29] transition-all hover:shadow-sm shrink-0"
            >
              {category}
            </button>
          ))}
        </div>
      </div>

      {/* Grid Layout (Grocery Product Cards) */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
        {(showAllProducts ? filteredProducts : filteredProducts.slice(0, 8)).map((item, index) => {
          const firstImage = Array.isArray(item.images) && item.images.length > 0 ? item.images[0] : item.image;
          const imageUrl = getImageUrl(firstImage || '');

          return (
            <div
              key={item._id || index}
              onClick={() => openItem(item, 'products')}
              className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-md border border-slate-200/80 transition-all duration-300 flex flex-col justify-between cursor-pointer relative"
            >
              {/* Top Image Container */}
              <div className="relative w-full h-36 sm:h-44 md:h-48 overflow-hidden bg-slate-50 p-3 flex items-center justify-center">
                {imageUrl ? (
                  <img 
                    src={imageUrl} 
                    alt={item.name} 
                    className="w-full h-full object-contain transition-transform duration-300 group-hover:scale-105" 
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center bg-slate-100 text-slate-300">
                    <Package size={32} />
                  </div>
                )}

                {/* Category / Fresh Badge */}
                <div className="absolute top-2.5 left-2.5 z-10">
                  <span className="bg-emerald-100/90 text-[#053B29] text-[10px] px-2.5 py-0.5 rounded-full font-bold uppercase tracking-wider">
                    {item.category || 'Fresco'}
                  </span>
                </div>
              </div>

              {/* Product Info & Direct Add Action */}
              <div className="p-3.5 sm:p-4 flex flex-col justify-between flex-1 bg-white">
                <div>
                  <h3 className="text-xs sm:text-sm font-bold text-slate-800 group-hover:text-[#053B29] transition-colors duration-200 line-clamp-2 leading-tight mb-1">
                    {item.name}
                  </h3>

                  <p className="text-slate-400 text-[11px] line-clamp-1 mb-3 font-normal">
                    {item.description || "Ingredientes selecionados e frescos."}
                  </p>
                </div>

                {/* Price Tag & Quick Add Button */}
                <div className="pt-2 border-t border-slate-100 flex items-center justify-between gap-2">
                  <div className="flex flex-col">
                    <span className="text-[10px] text-slate-400 font-medium uppercase leading-none">
                      Preço
                    </span>
                    <span className="text-sm sm:text-base font-extrabold text-[#053B29]">
                      {getItemPrice(item).toLocaleString()} <span className="text-xs font-bold">{currency}</span>
                    </span>
                  </div>

                  {/* Fast Add-to-Cart Action */}
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      // Função para adicionar rapidamente ao carrinho
                      if (typeof addToCart === 'function') {
                        addToCart(item);
                      } else {
                        openItem(item, 'products');
                      }
                    }}
                    aria-label="Adicionar ao Carrinho"
                    className="w-8 h-8 sm:w-9 sm:h-9 rounded-xl bg-slate-100 hover:bg-[#053B29] text-slate-800 hover:text-white flex items-center justify-center transition-all duration-200 shadow-sm shrink-0 active:scale-95"
                  >
                    <Plus size={18} />
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Expand / Toggle Products Button */}
      <div className="mt-10 md:mt-14 flex justify-center">
        <button 
          onClick={() => setShowAllProducts(prev => !prev)}
          className="group flex items-center gap-2 px-7 py-3 bg-[#053B29] hover:bg-[#03281c] text-white rounded-full font-bold transition-all shadow-md hover:shadow-lg text-xs md:text-sm"
        >
          <span>{showAllProducts ? 'Mostrar Menos' : 'Ver Todos os Produtos'}</span>
          <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-300 text-amber-400" />
        </button>
      </div>

    </div>
  </section>
)}

      {/* ABOUT SECTION */}

{/* SERVICES / ADVANTAGES SECTION (Grocery Centered) */}
{filteredServices.length > 0 && (
  <section id="services" className="py-12 md:py-20 bg-slate-50 relative overflow-hidden text-slate-900">
    
    {/* Subtle Grocery Grid Background */}
    <div 
      className="absolute inset-0 opacity-[0.02] pointer-events-none" 
      style={{
        backgroundImage: 'radial-gradient(#053B29 1.5px, transparent 1.5px)', 
        backgroundSize: '20px 20px'
      }} 
    />

    <div className="max-w-7xl mx-auto px-4 md:px-8 relative z-10">
      
      {/* Grid Layout Container */}
       {/* Section Header Card (First Slot in Grid) */}
        <div className="flex flex-col justify-center space-y-4 pr-0 lg:pr-4">
          <div className="flex items-center gap-2">
            <span className="px-3 py-1 bg-emerald-100 text-[#053B29] font-extrabold text-[11px] rounded-full uppercase tracking-wider">
              ✦ Nossos Serviços ✦
            </span>
          </div>

          <h2 className="text-3xl sm:text-4xl font-extrabold text-[#053B29] leading-tight tracking-tight">
            Serviços & <br />
            <span className="text-emerald-700">Conveniência para Si</span>
          </h2>

          <p className="text-slate-500 text-xs md:text-sm leading-relaxed max-w-sm">
            Garantimos uma experiência de compra rápida, conveniente e focada na máxima frescura dos seus produtos do dia a dia.
          </p>
        </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mt-9 gap-6 md:gap-8 items-stretch">
        
       

        {/* Dynamic Service Cards */}
        {filteredServices.slice(0, visibleServices).map((item, index) => {
          // Seleção de ícones dinâmicos de acordo com a posição ou tipo
          const serviceIcons = [Truck, Clock, ShieldCheck, HeartHandshake, Package];
          const IconComponent = serviceIcons[index % serviceIcons.length];

          return (
            <div
              key={item._id || index}
              onClick={() => openItem(item, 'services')}
              className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-md border border-slate-200/80 transition-all duration-300 flex flex-col cursor-pointer"
            >
              {/* Card Image Wrapper */}
              <div className="relative w-full h-44 md:h-48 overflow-hidden bg-slate-100">
                {item.images?.length > 0 ? (
                  <img 
                    src={getImageUrl(item.images[0])} 
                    alt={item.name}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                ) : (
                  <img 
                    src={`https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&q=80&w=600`}
                    alt="Grocery Service"
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                )}

                {/* Popular / Highlights Badge Overlay */}
                {index === 0 && (
                  <div className="absolute top-3 right-3 z-10">
                    <span className="bg-amber-400 text-slate-950 text-[10px] px-3 py-1 rounded-full font-black shadow-sm uppercase tracking-wider">
                      Mais Usado
                    </span>
                  </div>
                )}
              </div>

              {/* Card Body Info */}
              <div className="p-5 md:p-6 flex items-start gap-4 flex-1 bg-white">
                {/* Circular Icon */}
                <div className="w-10 h-10 rounded-xl bg-emerald-50 border border-emerald-100 flex items-center justify-center shrink-0 mt-0.5 group-hover:bg-[#053B29] group-hover:border-[#053B29] transition-colors duration-300">
                  <IconComponent className="text-[#053B29] group-hover:text-amber-400 transition-colors duration-300" size={20} />
                </div>

                {/* Content */}
                <div className="space-y-1.5 flex-1">
                  <h3 className="text-sm md:text-base font-bold text-slate-800 group-hover:text-[#053B29] transition-colors duration-200">
                    {item.name}
                  </h3>
                  <p className="text-slate-500 text-xs leading-relaxed line-clamp-3 font-normal">
                    {item.description || "Entregas agendadas e garantia de qualidade em todos os produtos diretamente na sua casa."}
                  </p>
                </div>
              </div>
            </div>
          );
        })}

      </div>

      {/* Expand / Load More Button */}
      {visibleServices < filteredServices.length && (
        <div className="mt-10 md:mt-14 flex justify-center">
          <button 
            onClick={() => setVisibleServices(prev => prev + 3)}
            className="group flex items-center gap-2.5 px-8 py-3.5 bg-[#053B29] hover:bg-[#03281c] text-white rounded-full font-bold transition-all shadow-md hover:shadow-lg text-xs md:text-sm"
          >
            <span>Ver Mais Serviços</span>
            <Plus size={16} className="group-hover:rotate-90 transition-transform duration-300 text-amber-400" />
          </button>
        </div>
      )}

    </div>
  </section>
)}

{/* MISSION, VISION, VALUES (Grocery Centered Layout) */}
{portalContent?.missionVision?.enabled && (
  <section className="py-12 md:py-20 bg-slate-50 px-4 md:px-8">
    <div className="max-w-7xl mx-auto bg-[#053B29] rounded-[28px] md:rounded-[40px] pt-12 md:pt-16 pb-16 md:pb-20 px-6 md:px-12 relative overflow-hidden text-center shadow-xl">
      
      {/* Background Radial Pattern */}
      <div 
        className="absolute inset-0 opacity-10 pointer-events-none" 
        style={{
          backgroundImage: 'radial-gradient(#fff 1px, transparent 1px)', 
          backgroundSize: '20px 20px'
        }} 
      />

      {/* Header Badge & Title */}
      <div className="relative z-10 mb-10 md:mb-14 space-y-3 max-w-2xl mx-auto">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/10 backdrop-blur-md border border-white/15 text-amber-300 text-xs font-semibold tracking-wide">
          <span>✦ Porquê Escolher-nos ✦</span>
        </div>

        <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-white tracking-tight leading-tight">
          Qualidade e Frescura <br />
          <span className="text-amber-400">Entregues à Sua Porta</span>
        </h2>
      </div>

      {/* Grid Layout Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 relative z-10 text-left">
        
        {/* Mission Card */}
        <div className="group bg-white p-6 md:p-8 rounded-2xl transition-all duration-300 hover:-translate-y-1 shadow-md border border-slate-100 relative overflow-hidden flex flex-col justify-between">
          <div className="absolute top-0 left-0 right-0 h-1 bg-amber-400 opacity-0 group-hover:opacity-100 transition-opacity" />
          
          <div>
            <div className="w-12 h-12 bg-emerald-50 rounded-xl flex items-center justify-center mb-5 text-[#053B29] group-hover:bg-[#053B29] group-hover:text-amber-400 transition-colors duration-300">
              <Target size={22} />
            </div>
            
            <h3 className="text-lg md:text-xl font-bold text-slate-900 mb-2">
              {portalContent?.missionVision?.mission?.title || "Nossa Missão"}
            </h3>
            
            <p className="text-slate-500 text-xs md:text-sm leading-relaxed mb-6 font-normal">
              {portalContent?.missionVision?.mission?.content || "Proporcionar o acesso fácil e rápido a produtos frescos, saudáveis e de qualidade superior, facilitando a rotina do seu lar todos os dias."}
            </p>
          </div>

          <div>
            <button className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-[#053B29] hover:text-emerald-700 border-b-2 border-[#053B29]/20 hover:border-[#053B29] pb-0.5 transition-all">
              <span>Saber Mais</span>
              <ArrowUpRight size={14} />
            </button>
          </div>
        </div>

        {/* Vision Card */}
        <div className="group bg-white p-6 md:p-8 rounded-2xl transition-all duration-300 hover:-translate-y-1 shadow-md border border-slate-100 relative overflow-hidden flex flex-col justify-between">
          <div className="absolute top-0 left-0 right-0 h-1 bg-amber-400 opacity-0 group-hover:opacity-100 transition-opacity" />

          <div>
            <div className="w-12 h-12 bg-emerald-50 rounded-xl flex items-center justify-center mb-5 text-[#053B29] group-hover:bg-[#053B29] group-hover:text-amber-400 transition-colors duration-300">
              <Eye size={22} />
            </div>

            <h3 className="text-lg md:text-xl font-bold text-slate-900 mb-2">
              {portalContent?.missionVision?.vision?.title || "Nossa Visão"}
            </h3>

            <p className="text-slate-500 text-xs md:text-sm leading-relaxed mb-6 font-normal">
              {portalContent?.missionVision?.vision?.content || "Ser a plataforma de supermercado online de referência e de maior confiança, reconhecida pela excelência no serviço e pelo compromisso com o frescor."}
            </p>
          </div>

          <div>
            <button className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-[#053B29] hover:text-emerald-700 border-b-2 border-[#053B29]/20 hover:border-[#053B29] pb-0.5 transition-all">
              <span>Saber Mais</span>
              <ArrowUpRight size={14} />
            </button>
          </div>
        </div>

        {/* Core Values Card */}
        <div className="group bg-white p-6 md:p-8 rounded-2xl transition-all duration-300 hover:-translate-y-1 shadow-md border border-slate-100 relative overflow-hidden flex flex-col justify-between md:col-span-2 lg:col-span-1">
          <div className="absolute top-0 left-0 right-0 h-1 bg-amber-400 opacity-0 group-hover:opacity-100 transition-opacity" />

          <div>
            <div className="w-12 h-12 bg-emerald-50 rounded-xl flex items-center justify-center mb-5 text-[#053B29] group-hover:bg-[#053B29] group-hover:text-amber-400 transition-colors duration-300">
              <ShieldCheck size={22} />
            </div>

            <h3 className="text-lg md:text-xl font-bold text-slate-900 mb-3">
              {portalContent?.missionVision?.values?.title || "Nossos Valores"}
            </h3>

            <ul className="grid grid-cols-2 gap-3 mb-6">
              {(portalContent?.missionVision?.values?.items?.length > 0 
                ? portalContent.missionVision.values.items 
                : ["Frescura Total", "Pontualidade", "Higiene Rigorosa", "Preço Justo"]
              ).map((value, i) => (
                <li key={i} className="flex items-center gap-2 text-xs font-bold text-slate-700">
                  <CheckCircle2 size={14} className="text-emerald-600 shrink-0" />
                  <span>{value}</span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <button className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-[#053B29] hover:text-emerald-700 border-b-2 border-[#053B29]/20 hover:border-[#053B29] pb-0.5 transition-all">
              <span>Saber Mais</span>
              <ArrowUpRight size={14} />
            </button>
          </div>
        </div>

      </div>

      {/* Floating Bottom Call-To-Action Button */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 z-20">
        <a 
          href="#products"
          className="bg-amber-400 hover:bg-amber-300 text-slate-950 px-8 md:px-10 py-3.5 md:py-4 rounded-full font-extrabold uppercase tracking-wider text-xs md:text-sm shadow-lg hover:scale-105 transition-all flex items-center gap-2"
        >
          <span>Fazer Compras Agora</span>
          <ArrowUpRight size={16} />
        </a>
      </div>

    </div>
  </section>
)}



{/* BUNDLES - COMBO (Grocery Redesigned Layout) */}
{filteredBundles.some(b => b.type === 'Combo') && (
  <section className="py-14 md:py-20 bg-[#f8f7f2] relative overflow-hidden text-slate-900">
    
    {/* Subtle Decorative Leaf Accent */}
    <div className="absolute top-10 -right-16 opacity-5 pointer-events-none rotate-45">
      <Leaf size={240} className="text-[#0E7D83]" />
    </div>

    <div className="max-w-7xl mx-auto px-4 md:px-8 relative z-10">
      
      {/* Header Block Centered */}
      <div className="text-center max-w-2xl mx-auto mb-10 md:mb-14 space-y-2.5">
        <div className="inline-flex items-center gap-2 px-3.5 py-1 rounded-full bg-[#0E7D83]/10 text-[#0E7D83] text-xs font-black uppercase tracking-widest">
          <Sparkles size={14} className="text-[#0E7D83]" />
          <span>Ofertas Especiais</span>
        </div>

        <h2 className="text-3xl md:text-4xl font-black text-[#0E7D83] tracking-tight">
          Combos & Cabazes Especiais
        </h2>

        <p className="text-slate-500 text-xs md:text-sm font-normal leading-relaxed">
          Kits selecionados e cabazes da semana preparados para garantir máxima variedade com o melhor preço.
        </p>
      </div>

      {/* Grid Layout Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 items-stretch">
        {filteredBundles
          .filter(item => item.type === 'Combo')
          .map((item, index) => {
            const image = getImageUrl(item.image || '');

            return (
              <div
                key={item._id || index}
                onClick={() => openItem(item, 'bundles')}
                className="group bg-white rounded-3xl overflow-hidden border border-[#0E7D83]/10 shadow-sm hover:shadow-xl transition-all duration-300 flex flex-col justify-between cursor-pointer relative"
              >
                {/* Top Banner Tag */}
                <div className="absolute top-3 left-3 z-20">
                  <span className="bg-[#E5E65D] text-[#0E7D83] font-black text-[10px] uppercase tracking-wider px-3 py-1 rounded-full shadow-sm flex items-center gap-1">
                    <Tag size={12} /> Melhores Preços
                  </span>
                </div>

                {/* Bundle Cover Image */}
                <div className="relative w-full h-48 sm:h-52 overflow-hidden bg-slate-100">
                  {image ? (
                    <img 
                      src={image} 
                      alt={item.name} 
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" 
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center bg-slate-100 text-slate-300">
                      <Layers size={40} />
                    </div>
                  )}

                  {/* Gradient Overlay for Text legibility */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-60" />
                </div>

                {/* Card Content Details */}
                <div className="p-5 md:p-6 flex flex-col justify-between flex-1 bg-white">
                  <div>
                    <div className="flex items-center justify-between gap-2 mb-2">
                      <span className="text-[10px] font-extrabold text-[#0a5e63] uppercase tracking-wider">
                        Cabaz #{index + 1 < 10 ? `0${index + 1}` : index + 1}
                      </span>
                      
                      <div className="w-8 h-8 rounded-full bg-[#f8f7f2] text-[#0E7D83] group-hover:bg-[#E5E65D] flex items-center justify-center transition-colors duration-300 shrink-0">
                        <ArrowUpRight size={16} />
                      </div>
                    </div>

                    <h3 className="text-lg md:text-xl font-bold text-[#0E7D83] group-hover:text-[#0a5e63] transition-colors leading-snug mb-2">
                      {item.name}
                    </h3>

                    <p className="text-slate-500 text-xs leading-relaxed line-clamp-3 mb-6 font-normal">
                      {item.description || "Combinação perfeita de produtos selecionados a dedo para a despensa da sua casa."}
                    </p>
                  </div>

                  {/* Bottom Price & Purchase Action */}
                  <div className="pt-4 border-t border-slate-100 flex items-center justify-between gap-3">
                    <div>
                      <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider block">
                        Preço do Cabaz
                      </span>
                      <div className="text-xl md:text-2xl font-black text-[#0E7D83]">
                        {getBundlePriceLabel(item)}
                      </div>
                    </div>

                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        if (typeof addToCart === 'function') {
                          addToCart(item);
                        } else {
                          openItem(item, 'bundles');
                        }
                      }}
                      className="bg-[#0E7D83] hover:bg-[#0a5e63] text-white px-4 py-2.5 rounded-2xl text-xs font-bold transition-all shadow-sm flex items-center gap-2 active:scale-95 shrink-0"
                    >
                      <ShoppingBag size={15} className="text-[#E5E65D]" />
                      <span>Comprar</span>
                    </button>
                  </div>

                </div>
              </div>
            );
          })}
      </div>

    </div>
  </section>
)}

{/* SUBSCRIPTIONS / RECURRING DELIVERIES (Grocery Style) */}
{filteredBundles.some(b => b.type === 'Subscription') && (
  <section className="py-14 md:py-20 bg-slate-50 text-slate-900 relative overflow-hidden">
    
    {/* Subtle Grid Accent Background */}
    <div 
      className="absolute inset-0 opacity-[0.02] pointer-events-none" 
      style={{
        backgroundImage: 'radial-gradient(#053B29 1.5px, transparent 1.5px)', 
        backgroundSize: '20px 20px'
      }} 
    />

    <div className="max-w-7xl mx-auto px-4 md:px-8 relative z-10">
      
      {/* Header Section */}
      <div className="flex flex-col items-center text-center mb-10 md:mb-14 max-w-2xl mx-auto">
        <div className="inline-flex items-center gap-2 px-3.5 py-1 rounded-full bg-emerald-100/80 text-[#053B29] text-xs font-black uppercase tracking-wider mb-3">
          <Calendar size={14} className="text-[#053B29]" />
          <span>Planos de Recorrência</span>
        </div>

        <h2 className="text-3xl md:text-4xl font-extrabold text-[#053B29] mb-3 tracking-tight">
          Assinaturas de Compras
        </h2>

        <p className="text-slate-500 text-xs md:text-sm leading-relaxed mb-6">
          Receba seus produtos essenciais diretamente em casa com frequência agendada, sem preocupações e com descontos exclusivos.
        </p>

        {/* Frequency Toggle Switch (Semanal / Mensal) */}
        <div className="inline-flex items-center gap-3 p-1.5 bg-white border border-slate-200 rounded-full shadow-sm">
          <span className="text-xs font-bold text-slate-500 pl-3">Semanal</span>
          <div className="w-12 h-6 bg-slate-100 rounded-full p-0.5 flex items-center relative cursor-pointer border border-slate-200">
            <div className="w-5 h-5 bg-[#053B29] rounded-full shadow-sm transition-transform" />
          </div>
          <span className="text-xs font-bold text-slate-900 pr-3 flex items-center gap-1.5">
            Mensal
            <span className="bg-amber-100 text-amber-900 text-[9px] font-black px-2 py-0.5 rounded-full uppercase">
              Economize 15%
            </span>
          </span>
        </div>
      </div>

      {/* Subscription Cards Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 items-stretch">
        {filteredBundles.filter(item => item.type === 'Subscription').map((plan, index) => {
          // Destaca o segundo cartão como plano recomendado
          const isFeatured = index === 1;

          return (
            <div 
              key={plan._id || index} 
              className={`relative p-6 md:p-8 rounded-3xl flex flex-col justify-between group transition-all duration-300 bg-white border ${
                isFeatured 
                  ? 'border-[#053B29] shadow-xl md:-translate-y-2 ring-1 ring-[#053B29]' 
                  : 'border-slate-200/80 shadow-sm hover:shadow-md'
              }`}
            >
              {/* Featured Badge */}
              {isFeatured && (
                <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 z-20">
                  <span className="bg-[#053B29] text-amber-300 text-[10px] font-black uppercase tracking-widest px-4 py-1 rounded-full shadow-sm border border-emerald-800">
                    Mais Recomendado
                  </span>
                </div>
              )}

              {/* Card Top Info */}
              <div>
                <div className="flex justify-between items-start mb-4">
                  <h3 className="text-xl md:text-2xl font-black text-slate-800">
                    {plan.name}
                  </h3>
                  <div className="w-9 h-9 rounded-xl bg-emerald-50 border border-emerald-100 flex items-center justify-center text-[#053B29] shrink-0">
                    <ShieldCheck size={20} />
                  </div>
                </div>

                <p className="text-slate-500 text-xs leading-relaxed mb-6 line-clamp-2 font-normal">
                  {plan.description || "Plano completo de entregas periódicas de produtos frescos com prioridade de envio."}
                </p>

                {/* Pricing Display */}
                <div className="flex items-baseline gap-1.5 pb-6 mb-6 border-b border-slate-100">
                  <span className="text-3xl md:text-4xl font-black text-[#053B29]">
                    {getItemPrice(plan).toLocaleString()}
                  </span>
                  <span className="text-xs font-bold text-slate-400 uppercase">{currency} / mês</span>
                </div>

                {/* Features List */}
                <div className="space-y-3 mb-8">
                  <p className="text-[11px] font-black text-[#053B29] uppercase tracking-wider">
                    Vantagens Incluídas:
                  </p>
                  
                  <ul className="space-y-2.5">
                    {plan.includedLimits?.length > 0 ? (
                      plan.includedLimits.map((limit: any, i: number) => (
                        <li key={i} className="flex items-start gap-2.5 text-xs text-slate-600 font-medium">
                          <div className="w-4 h-4 rounded-full bg-emerald-100 text-[#053B29] flex items-center justify-center shrink-0 mt-0.5">
                            <Check size={10} strokeWidth={3} />
                          </div>
                          <span className="leading-tight">{limit.description}</span>
                        </li>
                      ))
                    ) : (
                      <>
                        <li className="flex items-start gap-2.5 text-xs text-slate-600 font-medium">
                          <div className="w-4 h-4 rounded-full bg-emerald-100 text-[#053B29] flex items-center justify-center shrink-0 mt-0.5">
                            <Check size={10} strokeWidth={3} />
                          </div>
                          <span className="leading-tight">Entregas grátis em todos os pedidos</span>
                        </li>
                        <li className="flex items-start gap-2.5 text-xs text-slate-600 font-medium">
                          <div className="w-4 h-4 rounded-full bg-emerald-100 text-[#053B29] flex items-center justify-center shrink-0 mt-0.5">
                            <Check size={10} strokeWidth={3} />
                          </div>
                          <span className="leading-tight">Desconto fixo de 10% no checkout</span>
                        </li>
                      </>
                    )}
                  </ul>
                </div>
              </div>

              {/* Action CTA Button */}
              <button 
                onClick={() => { 
                  if (typeof addToCart === 'function') {
                    addToCart(plan, 'bundles');
                  } else {
                    openItem(plan, 'bundles');
                  }
                }} 
                className={`w-full py-3.5 rounded-2xl font-extrabold text-xs uppercase tracking-wider transition-all duration-300 flex items-center justify-center gap-2 ${
                  isFeatured 
                    ? 'bg-[#053B29] hover:bg-[#03281c] text-white shadow-md hover:shadow-lg' 
                    : 'bg-slate-100 hover:bg-[#053B29] text-slate-800 hover:text-white'
                }`}
              >
                <span>Subscrever Plano</span>
                <ArrowUpRight size={15} />
              </button>

            </div>
          );
        })}
      </div>

    </div>
  </section>
)}

   {/* CLIENTS / PARTNERS */}
{portalContent?.clients?.enabled && portalContent.clients.items?.length > 0 && (
  <section className="py-12 md:py-16 bg-[#f8f9fa] border-b border-gray-200/60 relative overflow-hidden">
    
    {/* Subtle Dot-Matrix Background */}
    <div 
      className="absolute inset-0 opacity-[0.03] pointer-events-none" 
      style={{
        backgroundImage: 'radial-gradient(#000 1.5px, transparent 1.5px)', 
        backgroundSize: '24px 24px'
      }} 
    />

    <div className="max-w-7xl mx-auto px-4 md:px-8 relative z-10">
      <div className="flex flex-col items-center mb-8 md:mb-10 text-center">
        <span className="text-[#FF4500] font-bold text-xs uppercase tracking-wider">
          ✦ Trusted by Industry Leaders ✦
        </span>
      </div>

      {/* Logo Grid / Slider Wrapper */}
      <div className="flex flex-wrap justify-center items-center gap-6 md:gap-10">
        {portalContent.clients.items.map((client: any, i: number) => (
          <div 
            key={i} 
            className="group relative px-6 py-3.5 bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-md hover:border-gray-200 transition-all duration-300 flex items-center justify-center"
          >
            <img 
              src={getImageUrl(client.logo)} 
              alt={client.name || 'Client Logo'} 
              className="h-6 md:h-8 w-auto object-contain grayscale opacity-50 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-300" 
            />
          </div>
        ))}
      </div>
    </div>
  </section>
)}

{/* TESTIMONIALS */}
{portalContent?.testimonials?.enabled && portalContent.testimonials.items?.length > 0 && (
  <section id="testimonials" className="py-16 md:py-24 bg-[#f8f9fa] relative overflow-hidden text-gray-900">
    
    {/* Background Watermark Accent */}
    <div className="absolute top-10 right-10 opacity-[0.03] pointer-events-none">
      <Quote size={280} className="text-gray-900" />
    </div>

    <div className="max-w-7xl mx-auto px-4 md:px-8 relative z-10">
      
      {/* Header */}
      <div className="flex flex-col items-center text-center mb-12 md:mb-16 space-y-2">
        <span className="text-[#FF4500] font-bold text-xs uppercase tracking-wider">
          ✦ Testimonials ✦
        </span>

        <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-gray-900 tracking-tight">
          What Our Clients <span className="text-gray-900">Say About Us</span>
        </h2>

        <p className="text-gray-500 text-xs md:text-sm max-w-md leading-relaxed pt-1">
          Real feedback from companies that trust our global Grocerys networks every single day.
        </p>
      </div>

      {/* Testimonials Cards Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 items-stretch">
        {portalContent.testimonials.items.map((t: any, i: number) => {
          const isFeatured = i === 1;

          return (
            <div 
              key={i} 
              className={`p-6 md:p-8 rounded-2xl flex flex-col justify-between transition-all duration-300 bg-white border relative ${
                isFeatured 
                  ? 'border-[#FF4500] shadow-xl md:-translate-y-2' 
                  : 'border-gray-200/80 shadow-sm hover:shadow-md'
              }`}
            >
              {/* Top Bar Accent */}
              <div className={`absolute top-0 left-6 right-6 h-1 rounded-b-md ${
                isFeatured ? 'bg-[#FF4500]' : 'bg-transparent'
              }`} />

              <div>
                {/* Rating Stars */}
                <div className="flex items-center gap-1 mb-6">
                  {Array.from({ length: t.rating || 5 }).map((_, k) => (
                    <Star key={k} size={14} className="fill-[#FF4500] text-[#FF4500]" />
                  ))}
                </div>

                {/* Testimonial Quote */}
                <blockquote className="mb-8">
                  <p className="text-gray-700 text-sm md:text-base font-medium leading-relaxed italic">
                    "{t.text}"
                  </p>
                </blockquote>
              </div>

              {/* Author / Client Info */}
              <div className="flex items-center gap-3.5 pt-5 border-t border-gray-100">
                <div className="w-11 h-11 rounded-full bg-gray-100 overflow-hidden shrink-0 border border-gray-200">
                  {t.avatar ? (
                    <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center font-bold text-xs uppercase bg-[#FF4500]/10 text-[#FF4500]">
                      {t.name?.substring(0, 2) || 'CL'}
                    </div>
                  )}
                </div>

                <div className="space-y-0.5">
                  <p className="font-bold text-sm text-gray-900 leading-snug">
                    {t.name}
                  </p>
                  <p className="text-[11px] font-medium text-gray-400 uppercase tracking-wide">
                    {t.role} {t.company && `• ${t.company}`}
                  </p>
                </div>
              </div>

            </div>
          );
        })}
      </div>

    </div>
  </section>
)}

{/* ITEM DETAILS MODAL / DRAWER (Grocery Style Redesign) */}
{selectedItem && (
  <div className="fixed inset-0 z-[100] flex justify-end">
    {/* Dark Backdrop with Blur */}
    <div 
      className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm transition-opacity duration-500" 
      onClick={() => { setSelectedItem(null); setCurrentImgIndex(0); }} 
    />

    {/* Side Drawer Content Container */}
    <div className="relative w-full max-w-full lg:max-w-4xl bg-white shadow-2xl h-full overflow-y-auto z-10 animate-in slide-in-from-right duration-300 flex flex-col text-slate-900">
      
      {/* Floating Close Button */}
      <button 
        onClick={() => { setSelectedItem(null); setCurrentImgIndex(0); }} 
        className="fixed top-4 right-4 md:top-6 md:right-6 z-[110] w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-full bg-white text-slate-700 hover:text-white hover:bg-[#053B29] transition-all duration-300 shadow-lg border border-slate-200"
        aria-label="Fechar"
      >
        <X size={20} strokeWidth={2.5} />
      </button>

      <div className="flex flex-col lg:flex-row min-h-full">
        
        {/* Left Column: Image Preview & Thumbnails */}
        <div className="relative w-full lg:w-1/2 bg-[#f8f7f2] p-6 md:p-8 flex flex-col justify-between border-b lg:border-b-0 lg:border-r border-slate-200/60">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="text-[#053B29] font-black text-[11px] uppercase tracking-wider flex items-center gap-1.5 bg-emerald-100/80 px-3 py-1 rounded-full">
                <Tag size={13} /> Detalhes do Produto
              </span>
            </div>

            {/* Main Image Viewport */}
            <div className="relative group">
              {(() => {
                const itemImages = selectedItem.images && Array.isArray(selectedItem.images) && selectedItem.images.length > 0
                  ? selectedItem.images 
                  : selectedItem.image ? [selectedItem.image] : [];
                const imageUrl = getImageUrl(itemImages[currentImgIndex] || '');
                
                return (
                  <div className="w-full">
                    <div className="w-full h-72 md:h-96 lg:h-[380px] rounded-2xl overflow-hidden bg-white shadow-sm border border-slate-200/80 relative flex items-center justify-center p-2">
                      {imageUrl ? (
                        <img 
                          src={imageUrl} 
                          className="w-full h-full object-cover rounded-xl" 
                          alt={selectedItem.name} 
                        />
                      ) : (
                        <div className="w-full h-full flex items-center justify-center text-slate-300 bg-slate-100">
                          <Package size={64} />
                        </div>
                      )}
                    </div>

                    {/* Image Controls Dots */}
                    {itemImages.length > 1 && (
                      <div className="flex justify-center gap-2 mt-4">
                        {itemImages.map((_, idx) => (
                          <button 
                            key={idx}
                            onClick={() => setCurrentImgIndex(idx)}
                            className={`h-2 rounded-full transition-all duration-300 ${
                              idx === currentImgIndex ? 'w-8 bg-[#053B29]' : 'w-2 bg-slate-300 hover:bg-slate-400'
                            }`}
                          />
                        ))}
                      </div>
                    )}
                  </div>
                );
              })()}
            </div>
          </div>
        </div>

        {/* Right Column: Grocery Product Info & Add to Cart */}
        <div className="flex-1 p-6 md:p-8 lg:p-10 flex flex-col justify-between bg-white">
          <div>
            {/* Category & Rating */}
            <div className="flex items-center justify-between mb-4 gap-2">
              <span className="text-[10px] font-extrabold text-[#053B29] uppercase tracking-wider px-3 py-1 bg-emerald-50 rounded-full border border-emerald-200">
                {selectedItem.category || selectedItem.type || 'Fresco & Selecionado'}
              </span>

              <div className="flex items-center gap-1 bg-amber-50 px-2.5 py-1 rounded-full border border-amber-200/60">
                <div className="flex items-center gap-0.5">
                  {[1, 2, 3, 4, 5].map(s => (
                    <Star key={s} size={11} className="fill-amber-400 text-amber-400" />
                  ))}
                </div>
                <span className="text-[10px] font-bold text-amber-800 ml-1">5.0</span>
              </div>
            </div>

            {/* Title */}
            <h3 className="text-2xl md:text-3xl font-black text-slate-900 mb-3 tracking-tight leading-snug">
              {selectedItem.name}
            </h3>

            {/* Description */}
            <p className="text-slate-500 text-xs md:text-sm leading-relaxed mb-6 font-normal">
              {selectedItem.description || "Produtos selecionados com rigor de qualidade para garantir o melhor sabor e frescura na sua mesa."}
            </p>

            {/* Core Provisions / Feature / Items List */}
            <div className="space-y-3 mb-6">
              <h4 className="text-xs font-black text-[#053B29] uppercase tracking-wider mb-2">
                Conteúdo do Cabaz / Destaques:
              </h4>
              
              <div className="divide-y divide-slate-100 border-t border-b border-slate-100 max-h-48 overflow-y-auto">
                {(selectedItem.includedItems || selectedItem.items || []).length > 0 ? (
                  (selectedItem.includedItems || selectedItem.items).map((it: any, i: number) => (
                    <div key={i} className="flex items-center justify-between py-2.5">
                      <div className="flex items-center gap-2.5">
                        <div className="w-4 h-4 rounded-full bg-emerald-100 text-[#053B29] flex items-center justify-center shrink-0">
                          <Check size={10} strokeWidth={3} />
                        </div>
                        <span className="text-xs font-semibold text-slate-700">
                          {it.productId?.name || it.description || it.name || "Item Selecionado"}
                        </span>
                      </div>
                      {it.quantity && (
                        <span className="text-[11px] font-bold text-slate-400 bg-slate-100 px-2 py-0.5 rounded-md">
                          x{it.quantity}
                        </span>
                      )}
                    </div>
                  ))
                ) : (
                  <div className="py-3 text-xs text-slate-400 italic">
                    Garantia de seleção de itens frescos e de alta qualidade.
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Pricing & CTA Footer */}
          <div className="pt-6 border-t border-slate-100 mt-auto">
            <div className="flex flex-col gap-4">
              <div className="flex justify-between items-end">
                <div>
                  <span className="text-[10px] font-extrabold text-slate-400 uppercase tracking-wider block mb-0.5">
                    Preço Total
                  </span>
                  <div className="text-2xl md:text-3xl font-black text-[#053B29] tracking-tight">
                    {(activeCatalog === 'services' ? getServicePriceLabel(selectedItem) : getBundlePriceLabel(selectedItem))}
                  </div>
                </div>

                {selectedItem.billingCycle && (
                  <span className="text-xs font-bold text-emerald-700 bg-emerald-50 px-2.5 py-1 rounded-lg border border-emerald-200 uppercase">
                    Cobrança {selectedItem.billingCycle}
                  </span>
                )}
              </div>

              <button 
                onClick={() => { 
                  if (typeof addToCart === 'function') {
                    addToCart(selectedItem, activeCatalog);
                  }
                  setSelectedItem(null); 
                }}
                className="w-full py-3.5 bg-[#053B29] hover:bg-[#03281c] text-white font-extrabold text-xs uppercase tracking-wider rounded-2xl shadow-md hover:shadow-lg transition-all flex items-center justify-center gap-2 active:scale-95"
              >
                <ShoppingBag size={16} />
                <span>Adicionar ao Carrinho</span>
              </button>
            </div>
          </div>

        </div>

      </div>
    </div>
  </div>
)}

{/* CART / CHECKOUT MODAL DRAWER (Grocery & Fresh Food Redesign) */}
<div className={`fixed inset-0 z-[100] flex justify-end ${isCartOpen ? 'pointer-events-auto' : 'pointer-events-none'}`}>
  {/* Dark Overlay with Blur */}
  <div
    className={`absolute inset-0 bg-slate-900/60 backdrop-blur-sm transition-opacity duration-500 ${isCartOpen ? 'opacity-100' : 'opacity-0'}`}
    onClick={() => setIsCartOpen(false)}
  />

  {/* Main Drawer Container */}
  <div
    className={`relative w-full max-w-full lg:max-w-6xl bg-white shadow-2xl h-full transform transition-all duration-500 ease-out flex flex-col overflow-y-auto lg:overflow-hidden text-slate-900 ${isCartOpen ? 'translate-x-0' : 'translate-x-full'}`}
  >
    {/* Floating Close Button */}
    <button 
      onClick={() => setIsCartOpen(false)} 
      className="absolute top-4 right-4 md:top-6 md:right-6 z-[110] w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-full bg-white text-slate-700 hover:text-white hover:bg-[#053B29] transition-all duration-300 shadow-lg border border-slate-200"
      aria-label="Fechar Carrinho"
    >
      <X size={20} strokeWidth={2.5} />
    </button>

    <div className="flex flex-col lg:flex-row lg:h-full lg:overflow-hidden">
      
      {/* Left Column: Selected Cart Items List */}
      <div className="lg:flex-[1.3] lg:flex lg:flex-col bg-white lg:border-r border-slate-200/80 z-10">
        <div className="p-6 md:p-8 border-b border-slate-100">
          <div className="flex items-center gap-2 mb-1.5">
            <span className="text-[#053B29] font-black text-[11px] uppercase tracking-wider bg-emerald-100/80 px-3 py-0.5 rounded-full inline-flex items-center gap-1">
              <ShoppingBag size={13} /> O Seu Carrinho
            </span>
          </div>
          <h2 className="text-2xl md:text-3xl font-black text-slate-900 tracking-tight">
            Produtos Selecionados
          </h2>
        </div>

        {/* Scrollable Items Container */}
        <div className="lg:flex-1 lg:overflow-y-auto p-6 md:p-8 scrollbar-hide">
          {cart.length > 0 ? (
            <div className="space-y-4">
              {cart.map(cartItem => (
                <div 
                  key={cartItem.itemId} 
                  className="group relative flex items-center gap-4 p-4 bg-[#f8f7f2] rounded-2xl border border-slate-200/60 transition-all duration-300 hover:border-emerald-300"
                >
                  {/* Item Thumbnail */}
                  <div className="w-16 h-16 md:w-20 md:h-20 rounded-xl bg-white border border-slate-200 flex items-center justify-center p-2 shadow-sm shrink-0 overflow-hidden">
                    <img 
                      src={getImageUrl(cartItem.image)} 
                      alt={cartItem.name} 
                      className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300" 
                    />
                  </div>

                  {/* Item Meta & Actions */}
                  <div className="flex-1 min-w-0">
                    <p className="text-[10px] font-black text-[#053B29] uppercase tracking-wider mb-0.5">
                      {cartItem.category || 'Frescos & Mercearia'}
                    </p>
                    <h4 className="text-sm md:text-base font-bold text-slate-900 truncate">
                      {cartItem.name}
                    </h4>
                    <button 
                      onClick={() => removeFromCart(cartItem.itemId)} 
                      className="text-[10px] text-rose-600 hover:text-rose-800 transition-colors mt-2 uppercase font-extrabold tracking-wider flex items-center gap-1"
                    >
                      <X size={11} /> Remover
                    </button>
                  </div>

                  {/* Quantity Stepper & Price */}
                  <div className="flex flex-col items-end gap-2 shrink-0">
                    <div className="flex items-center bg-white rounded-full p-1 border border-slate-200 shadow-sm">
                      <button 
                        onClick={() => updateCartQuantity(cartItem.itemId, cartItem.quantity - 1)} 
                        className="p-1 md:p-1.5 text-slate-600 hover:text-[#053B29] hover:bg-slate-100 rounded-full transition-colors"
                      >
                        <Minus size={12} />
                      </button>
                      <span className="px-2.5 text-xs md:text-sm font-extrabold text-slate-900">
                        {cartItem.quantity}
                      </span>
                      <button 
                        onClick={() => updateCartQuantity(cartItem.itemId, cartItem.quantity + 1)} 
                        className="p-1 md:p-1.5 text-slate-600 hover:text-[#053B29] hover:bg-slate-100 rounded-full transition-colors"
                      >
                        <Plus size={12} />
                      </button>
                    </div>

                    <p className="text-sm md:text-base font-black text-[#053B29] tracking-tight">
                      {(cartItem.price * cartItem.quantity).toLocaleString()} <span className="text-[10px] font-bold text-slate-400">{currency}</span>
                    </p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="h-full flex flex-col items-center justify-center py-20 text-slate-400">
              <ShoppingBag size={56} strokeWidth={1.2} className="mb-4 text-slate-300" />
              <p className="text-xs font-bold uppercase tracking-widest text-slate-400">O seu carrinho está vazio</p>
              <p className="text-xs text-slate-400 mt-1">Adicione produtos frescos e cabazes para continuar.</p>
            </div>
          )}
        </div>

        {/* Continue Shopping Button */}
        <div className="p-6 md:p-8 bg-white border-t border-slate-100">
          <button 
            onClick={() => setIsCartOpen(false)}
            className="flex items-center gap-2 text-slate-500 hover:text-[#053B29] text-xs font-extrabold uppercase tracking-wider transition-colors group"
          >
            <ArrowLeft size={14} className="group-hover:-translate-x-1 transition-transform" /> 
            <span>Continuar a Comprar</span>
          </button>
        </div>
      </div>

      {/* Right Column: Delivery Details & Payment Checkout */}
      <div className="lg:flex-1 bg-[#f8f7f2] p-6 md:p-8 lg:p-10 lg:flex lg:flex-col lg:overflow-y-auto scrollbar-hide">
        <h3 className="text-xs font-black text-[#053B29] uppercase tracking-wider mb-6 flex items-center gap-2">
          <Tag size={14} /> Dados de Entrega & Pagamento
        </h3>

        <div className="flex-1 space-y-6">
          {/* Client Details Inputs */}
          <div className="grid grid-cols-1 gap-3">
            <div>
              <label className="text-[10px] font-extrabold uppercase text-slate-500 ml-1 mb-1 block tracking-wider">
                Nome Completo / Empresa
              </label>
              <input 
                placeholder="Ex: Maria Silva ou Empresa Lda" 
                value={client.name} 
                onChange={e => setClient({ ...client, name: e.target.value })} 
                className="w-full px-4 py-3 bg-white border border-slate-200 rounded-xl text-xs font-bold text-slate-900 focus:ring-2 focus:ring-[#053B29]/20 focus:border-[#053B29] outline-none transition-all shadow-sm" 
              />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div>
                <label className="text-[10px] font-extrabold uppercase text-slate-500 ml-1 mb-1 block tracking-wider">
                  E-mail
                </label>
                <input 
                  placeholder="exemplo@email.com" 
                  type="email" 
                  value={client.email} 
                  onChange={e => setClient({ ...client, email: e.target.value })} 
                  className="w-full px-4 py-3 bg-white border border-slate-200 rounded-xl text-xs font-bold text-slate-900 focus:ring-2 focus:ring-[#053B29]/20 focus:border-[#053B29] outline-none transition-all shadow-sm" 
                />
              </div>

              <div>
                <label className="text-[10px] font-extrabold uppercase text-slate-500 ml-1 mb-1 block tracking-wider">
                  Telefone / Celular
                </label>
                <input 
                  type="number" 
                  placeholder="84 / 86 XXX XXXX" 
                  value={client.phone} 
                  onChange={e => setClient({ ...client, phone: e.target.value })} 
                  className="w-full px-4 py-3 bg-white border border-slate-200 rounded-xl text-xs font-bold text-slate-900 focus:ring-2 focus:ring-[#053B29]/20 focus:border-[#053B29] outline-none transition-all shadow-sm" 
                />
              </div>
            </div>

            <div>
              <label className="text-[10px] font-extrabold uppercase text-slate-500 ml-1 mb-1 block tracking-wider">
                Endereço de Entrega / Observações
              </label>
              <textarea 
                placeholder="Indique a morada, ponto de referência ou instruções de entrega..." 
                rows={3} 
                value={client.notes || ""} 
                onChange={e => setClient({ ...client, notes: e.target.value })} 
                className="w-full px-4 py-3 bg-white border border-slate-200 rounded-xl text-xs font-bold text-slate-900 focus:ring-2 focus:ring-[#053B29]/20 focus:border-[#053B29] outline-none transition-all shadow-sm resize-none" 
              />
            </div>
          </div>

          {/* Payment Method Selector */}
          <div className="space-y-3">
            <label className="text-[10px] font-extrabold uppercase tracking-wider text-slate-500 block ml-1">
              Método de Pagamento
            </label>
            <div className="grid grid-cols-2 gap-2">
              {['mpesa', 'visa', 'emola', 'transfer'].map((m) => (
                <button
                  key={m}
                  type="button"
                  onClick={() => { setPaymentMethod(m as any); setMobileMoneyPhone(''); }}
                  className={`py-3 rounded-xl text-xs font-extrabold uppercase tracking-wider transition-all duration-300 flex items-center justify-center gap-2 border ${
                    paymentMethod === m 
                      ? 'bg-[#053B29] text-white border-[#053B29] shadow-md' 
                      : 'bg-white text-slate-700 border-slate-200 hover:bg-slate-50'
                  }`}
                >
                  {m === 'emola' ? 'e-Mola' : m === 'transfer' ? 'Transferência' : m}
                  {paymentMethod === m && <Check size={12} className="text-[#E5E65D]" strokeWidth={3} />}
                </button>
              ))}
            </div>

            {/* Mobile Money Phone Input */}
            {(paymentMethod === 'mpesa' || paymentMethod === 'emola') && (
              <div className="flex flex-col gap-1.5 pt-1">
                <input
                  type="tel"
                  value={mobileMoneyPhone}
                  onChange={e => setMobileMoneyPhone(e.target.value)}
                  placeholder={paymentMethod === 'mpesa' ? '+258 84 / 85 XXX XXXX' : '+258 86 / 87 XXX XXXX'}
                  className="w-full px-4 py-3 bg-white border border-slate-200 rounded-xl text-xs font-bold text-slate-900 focus:ring-2 focus:ring-[#053B29]/20 focus:border-[#053B29] outline-none shadow-sm"
                />
                <p className="text-[10px] text-slate-400 font-medium ml-1">
                  {paymentMethod === 'mpesa'
                    ? 'O número deve começar com 84 ou 85'
                    : 'O número deve começar com 86 ou 87'}
                </p>
              </div>
            )}
          </div>

          {/* Bank Transfer Information */}
          {paymentMethod === 'transfer' && (
            <div className="p-4 bg-white border border-slate-200 text-slate-900 rounded-2xl shadow-sm">
              <h4 className="text-xs font-black uppercase tracking-wider mb-3 flex items-center gap-2 text-[#053B29]">
                <CreditCard size={14} /> Dados Bancários para Transferência
              </h4>
              <div className="space-y-3">
                {company.bankAccounts?.map((bank, idx) => (
                  <div key={idx} className="border-b border-slate-100 pb-2.5 last:border-0 last:pb-0">
                    <p className="text-xs font-extrabold uppercase text-slate-800 mb-1">{bank.bankName}</p>
                    <div className="grid grid-cols-2 gap-2 text-[11px] font-mono text-slate-600">
                      <div>
                        <p className="text-[9px] uppercase text-slate-400">Conta</p>
                        <p className="font-bold">{bank.accountNumber}</p>
                      </div>
                      <div>
                        <p className="text-[9px] uppercase text-slate-400">NIB/IBAN</p>
                        <p className="font-bold">{bank.nibOrIban}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Grand Total & Submission Buttons */}
        <div className="mt-8 pt-6 border-t border-slate-200/80">
          <div className="flex justify-between items-end mb-6">
            <div>
              <span className="text-[10px] font-extrabold text-slate-400 uppercase tracking-wider block mb-0.5">
                Valor Total a Pagar
              </span>
              <div className="text-3xl md:text-4xl font-black text-[#053B29] tracking-tight">
                {totals.grandTotal.toLocaleString()} <span className="text-xs font-bold text-slate-400">{currency}</span>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-3">
            {/* Online Payment Gateway Button */}
            <button
              onClick={handlePayment}
              disabled={!paymentMethod || !['mpesa', 'visa', 'emola'].includes(paymentMethod) || ((paymentMethod === 'mpesa' || paymentMethod === 'emola') && !mobileMoneyPhone)}
              className="w-full py-3.5 bg-[#053B29] hover:bg-[#03281c] text-white text-xs font-extrabold uppercase tracking-wider rounded-2xl transition-all shadow-md hover:shadow-lg disabled:opacity-30 disabled:hover:bg-[#053B29] active:scale-95 flex items-center justify-center gap-2"
            >
              <Lock size={14} /> 
              {hasOrderWithPrice ? `Pagar com Segurança (${totals.grandTotal.toLocaleString()} ${currency})` : 'Iniciar Pagamento'}
            </button>

            {/* Manual Direct Confirmation Button */}
            <button
              onClick={handleSubmit}
              disabled={submitting || !client.name || !client.email || (hasOrderWithPrice && ['mpesa', 'visa', 'emola'].includes(paymentMethod))}
              className="w-full py-3.5 bg-slate-900 hover:bg-slate-800 text-white text-xs font-extrabold uppercase tracking-wider rounded-2xl transition-all disabled:opacity-30 active:scale-95 shadow-sm"
            >
              {paymentMethod === 'transfer' ? 'Confirmar Comprovativo de Transferência' : 'Finalizar Pedido'}
            </button>
          </div>
        </div>

      </div>

    </div>
  </div>
</div>

 {/* SUCCESS MODAL (Grocery & Fresh Food Redesign) */}
{showSuccessModal && (
  <div 
    className="fixed inset-0 z-[110] flex items-center justify-center p-4 md:p-6 bg-slate-900/60 backdrop-blur-sm animate-in fade-in duration-300" 
    onClick={closeSuccessModal}
  >
    <div
      className="bg-white shadow-2xl max-w-sm md:max-w-md w-full relative overflow-hidden transition-all transform scale-100 rounded-3xl border border-slate-100 text-slate-900"
      onClick={e => e.stopPropagation()}
    >
      {/* Top Accent Line */}
      <div className="absolute top-0 left-0 w-full h-2 bg-[#053B29]" />

      <div className="p-8 md:p-10 text-center">
        {/* Animated Check Icon Badge */}
        <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-emerald-50 rounded-full mb-6 relative">
          <div className="w-10 h-10 md:w-12 md:h-12 bg-[#053B29] rounded-full flex items-center justify-center text-[#E5E65D] shadow-lg shadow-[#053B29]/20">
            <Check size={22} strokeWidth={3} />
          </div>
        </div>

        {/* Header & Message */}
        <div className="space-y-2 mb-8">
          <span className="text-[10px] font-black uppercase tracking-wider text-[#053B29] bg-emerald-100/80 px-3 py-1 rounded-full inline-block">
            Pedido Confirmado!
          </span>

          <h2 className="text-2xl md:text-3xl font-black text-slate-900 leading-tight tracking-tight pt-1">
            Muito obrigado pela compra
          </h2>

          <p className="text-slate-500 text-xs md:text-sm leading-relaxed max-w-[300px] mx-auto pt-1">
            O seu pedido foi recebido com sucesso. Enviamos os detalhes e o comprovante para o seu e-mail.
          </p>
        </div>

        {/* Action Button */}
        <button
          onClick={closeSuccessModal}
          className="w-full py-4 bg-[#053B29] hover:bg-[#03281c] text-white rounded-2xl font-extrabold text-xs uppercase tracking-wider shadow-md hover:shadow-lg transition-all active:scale-95 mb-6"
        >
          Voltar à Loja
        </button>

        {/* Reference Order Section */}
        <div className="pt-6 border-t border-dashed border-slate-200 flex flex-col items-center gap-1.5">
          <p className="text-[10px] font-extrabold uppercase tracking-wider text-slate-400">
            Número do Pedido
          </p>
          <span className="font-mono text-xs md:text-sm font-extrabold text-[#053B29] tracking-wider bg-[#f8f7f2] px-4 py-1.5 rounded-xl border border-slate-200/80">
            #PED-{Math.random().toString(36).substr(2, 5).toUpperCase()}
          </span>
        </div>
      </div>
    </div>
  </div>
)}

{/* FOOTER (Grocery & Fresh Food Redesign) */}
<footer className="bg-[#03281c] text-white pt-16 md:pt-24 pb-8 md:pb-12 overflow-hidden relative border-t border-emerald-950">
  {/* Subtle Radial Grid Overlay */}
  <div 
    className="absolute inset-0 opacity-[0.04] pointer-events-none" 
    style={{ backgroundImage: 'radial-gradient(#E5E65D 1px, transparent 1px)', backgroundSize: '32px 32px' }} 
  />

  <div className="max-w-7xl mx-auto px-4 md:px-6 relative z-10">
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-10 md:gap-16 mb-16 md:mb-20">
      
      {/* Brand & Newsletter Column */}
      <div className="sm:col-span-2 lg:col-span-4 space-y-6 md:space-y-8">
        <div className="flex items-center">
          {company.logo ? (
            <img src={company.logo} alt={company.name} className="h-8 md:h-10 w-auto brightness-0 invert" />
          ) : (
            <span className="font-black text-xl md:text-2xl tracking-tight text-white uppercase flex items-center gap-1">
              {company.name}<span className="text-[#E5E65D]">.</span>
            </span>
          )}
        </div>

        <p className="text-emerald-100/70 text-xs md:text-sm leading-relaxed max-w-xs font-normal">
          Seu supermercado online de confiança. Entregamos produtos frescos, orgânicos e artigos essenciais de mercearia diretamente na sua porta.
        </p>

        {/* Newsletter Subscription */}
        <div className="space-y-3 pt-2">
          <div className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-[#E5E65D]" />
            <p className="text-[10px] font-black uppercase tracking-wider text-emerald-200">
              Receba Ofertas Exclusivas
            </p>
          </div>
          <div className="flex p-1.5 bg-emerald-950/80 border border-emerald-800/60 rounded-2xl focus-within:border-[#E5E65D] transition-all">
            <input 
              type="email" 
              placeholder="Digite o seu e-mail..." 
              className="flex-1 px-4 md:px-5 bg-transparent text-white text-xs outline-none placeholder:text-emerald-300/40 font-medium min-w-0" 
            />
            <button className="px-5 md:px-6 py-2.5 bg-[#E5E65D] text-[#053B29] rounded-xl text-xs font-black uppercase tracking-wider hover:bg-yellow-300 transition-all shadow-md whitespace-nowrap">
              Subscrever
            </button>
          </div>
        </div>
      </div>

      {/* Quick Links: Categorias */}
      <div className="lg:col-span-2 space-y-6">
        <h4 className="text-xs font-black uppercase tracking-wider text-emerald-300/80">
          Nossos Produtos
        </h4>
        <ul className="space-y-3 md:space-y-4">
          {['Frescos & Hortaliças', 'Frutas Selecionadas', 'Cabazes Especiais', 'Bebidas & Mercearia'].map(link => (
            <li key={link}>
              <a 
                href="#" 
                className="text-xs text-emerald-100/70 hover:text-[#E5E65D] transition-colors font-bold uppercase tracking-wider flex items-center gap-2 group"
              >
                <span className="w-0 group-hover:w-2.5 h-0.5 bg-[#E5E65D] transition-all" />
                {link}
              </a>
            </li>
          ))}
        </ul>
      </div>

      {/* Direct Contact & Support */}
      <div className="lg:col-span-3 space-y-6">
        <h4 className="text-xs font-black uppercase tracking-wider text-emerald-300/80">
          Apoio ao Cliente
        </h4>
        <ul className="space-y-5">
          <li className="flex flex-col gap-1">
            <span className="text-[10px] text-emerald-300/60 font-black uppercase tracking-wider">
              Encomendas & Linha Direta
            </span>
            <a 
              href={`tel:${company.phone}`} 
              className="text-white font-black text-xl md:text-2xl hover:text-[#E5E65D] transition-colors tracking-tight"
            >
              {company.phone}
            </a>
          </li>
          <li className="flex flex-col gap-1">
            <span className="text-[10px] text-emerald-300/60 font-black uppercase tracking-wider">
              Suporte por E-mail
            </span>
            <a 
              href={`mailto:${company.email}`} 
              className="text-emerald-100/80 font-bold text-xs md:text-sm hover:text-[#E5E65D] transition-colors tracking-tight break-all"
            >
              {company.email}
            </a>
          </li>
        </ul>
      </div>

      {/* Social & Payment Gateways */}
      <div className="lg:col-span-3 space-y-6">
        <div>
          <h4 className="text-xs font-black uppercase tracking-wider text-emerald-300/80 mb-4">
            Siga-nos
          </h4>
          <div className="flex gap-3">
            {[Instagram, Facebook, Linkedin].map((Icon, idx) => (
              <a 
                key={idx} 
                href="#" 
                className="w-10 h-10 rounded-2xl bg-emerald-950 border border-emerald-800/80 flex items-center justify-center text-emerald-200 hover:text-[#053B29] hover:bg-[#E5E65D] hover:border-[#E5E65D] transition-all duration-300 shadow-sm"
              >
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>

        <div className="space-y-3">
          <p className="text-[10px] font-black uppercase tracking-wider text-emerald-300/60">
            Formas de Pagamento
          </p>
          <div className="flex flex-wrap gap-2">
            {['M-PESA', 'VISA', 'E-MOLA', 'TRANSFERÊNCIA'].map(p => (
              <div 
                key={p} 
                className="px-3 py-1.5 border border-emerald-800/60 bg-emerald-950/60 rounded-xl text-[10px] font-black text-emerald-200 hover:border-emerald-600 transition-all"
              >
                {p}
              </div>
            ))}
          </div>
        </div>
      </div>

    </div>

    {/* Bottom Bar */}
    <div className="pt-8 border-t border-emerald-900/80 flex flex-col md:flex-row justify-between items-center gap-6">
      
      {/* Copyright & Commitments */}
      <div className="space-y-2 text-center md:text-left">
        <p className="text-xs font-black text-emerald-100/90 uppercase tracking-wider">
          © 2026 {company.name} <span className="text-emerald-400/60 font-bold">/ Todos os direitos reservados</span>
        </p>
        <div className="flex items-center justify-center md:justify-start gap-3 text-[10px] text-emerald-300/60 font-black uppercase tracking-wider">
          <span>FRESCURA GARANTIDA</span>
          <span className="w-1 h-1 rounded-full bg-emerald-700" />
          <span>ENTREGA NO MESMO DIA</span>
        </div>
      </div>

      {/* Privacy Links */}
      <div className="flex gap-6">
        <a href="#" className="text-xs font-extrabold text-emerald-200/80 hover:text-[#E5E65D] transition-colors uppercase tracking-wider">
          Privacidade
        </a>
        <a href="#" className="text-xs font-extrabold text-emerald-200/80 hover:text-[#E5E65D] transition-colors uppercase tracking-wider">
          Termos de Serviço
        </a>
      </div>

      {/* Live Operational Status Indicator */}
      <div className="flex items-center gap-2.5 px-4 py-2 bg-emerald-950/80 rounded-full border border-emerald-800/80">
        <div className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-400"></span>
        </div>
        <span className="text-[10px] font-black text-emerald-200 uppercase tracking-wider">
          Loja Aberta & Entregas Ativas
        </span>
      </div>

    </div>
  </div>
</footer>
    
{/* AWAITING CONFIRMATION MODAL (Grocery & Fresh Food Redesign) */}
{showAwaitingConfirmation && (
  <div className="fixed inset-0 z-[110] flex items-center justify-center p-4 md:p-6 bg-slate-900/60 backdrop-blur-sm animate-in fade-in duration-300">
    <div className="bg-white shadow-2xl max-w-sm md:max-w-md w-full relative overflow-hidden transition-all transform scale-100 rounded-3xl border border-slate-100 p-8 md:p-10 text-center text-slate-900">
      
      {/* Top Accent Line */}
      <div className="absolute top-0 left-0 w-full h-2 bg-[#053B29]" />

      {/* STATE 1: WAITING FOR PIN */}
      {pollStatus === 'waiting' && (
        <div className="space-y-6">
          <div className="relative w-16 h-16 md:w-20 md:h-20 mx-auto flex items-center justify-center">
            {/* Outer Soft Ring */}
            <div className="absolute inset-0 rounded-full border-4 border-[#053B29]/15" />
            {/* Spinning Accent Ring */}
            <div className="absolute inset-0 rounded-full border-4 border-[#053B29] border-t-[#E5E65D] animate-spin" />
            <Smartphone className="w-7 h-7 text-[#053B29] animate-pulse" />
          </div>

          <div className="space-y-2">
            <span className="text-[10px] font-black uppercase tracking-wider text-[#053B29] bg-emerald-100/80 px-3 py-1 rounded-full inline-block">
              Autorização no Telemóvel
            </span>
            <h3 className="text-xl md:text-2xl font-black text-slate-900 tracking-tight pt-1">
              Aguardando Confirmação
            </h3>
            <p className="text-xs md:text-sm text-slate-500 leading-relaxed max-w-[280px] mx-auto pt-1 font-medium">
              Enviamos um pedido de pagamento M-Pesa / e-Mola para o seu telefone.<br />
              <strong className="text-slate-800 font-extrabold">Digite o seu PIN</strong> para autorizar a compra.
            </p>
          </div>

          {awaitingRef && (
            <div className="pt-2">
              <span className="font-mono text-xs font-extrabold text-[#053B29] tracking-wider bg-[#f8f7f2] px-4 py-1.5 rounded-xl border border-slate-200/80 inline-block">
                Ref: {awaitingRef}
              </span>
            </div>
          )}
        </div>
      )}

      {/* STATE 2: PAYMENT CONFIRMED */}
      {pollStatus === 'confirmed' && (
        <div className="space-y-6">
          <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-emerald-50 rounded-full relative">
            <div className="w-10 h-10 md:w-12 md:h-12 bg-[#053B29] rounded-full flex items-center justify-center text-[#E5E65D] shadow-lg shadow-[#053B29]/20">
              <CheckCircle className="w-6 h-6" strokeWidth={2.5} />
            </div>
          </div>

          <div className="space-y-2">
            <span className="text-[10px] font-black uppercase tracking-wider text-[#053B29] bg-emerald-100/80 px-3 py-1 rounded-full inline-block">
              Aprovação Concluída
            </span>
            <h3 className="text-xl md:text-2xl font-black text-slate-900 tracking-tight pt-1">
              Pagamento Confirmado!
            </h3>
            <p className="text-xs md:text-sm text-slate-400 font-bold pt-1 flex items-center justify-center gap-2">
              <span className="w-2 h-2 rounded-full bg-emerald-500 animate-ping" />
              A preparar o seu pedido...
            </p>
          </div>
        </div>
      )}

      {/* STATE 3: PAYMENT FAILED / EXPIRED */}
      {pollStatus === 'failed' && (
        <div className="space-y-6">
          <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-rose-50 rounded-full">
            <div className="w-10 h-10 md:w-12 md:h-12 bg-rose-600 rounded-full flex items-center justify-center text-white shadow-md shadow-rose-600/30">
              <X className="w-6 h-6" strokeWidth={3} />
            </div>
          </div>

          <div className="space-y-2">
            <span className="text-[10px] font-black uppercase tracking-wider text-rose-600 bg-rose-100/80 px-3 py-1 rounded-full inline-block">
              Transação Não Concluída
            </span>
            <h3 className="text-xl md:text-2xl font-black text-slate-900 tracking-tight pt-1">
              Pagamento não verificado
            </h3>
            <p className="text-xs md:text-sm text-slate-500 leading-relaxed max-w-[280px] mx-auto pt-1 font-medium">
              A autorização no telemóvel foi recusada, cancelada ou o tempo limite expirou.
            </p>
          </div>

          <button
            onClick={() => setShowAwaitingConfirmation(false)}
            className="w-full py-3.5 bg-[#053B29] hover:bg-[#03281c] text-white rounded-2xl font-extrabold text-xs uppercase tracking-wider transition-all shadow-md active:scale-95"
          >
            Tentar Novamente
          </button>
        </div>
      )}

    </div>
  </div>
)}
</div>
  );
};

export default GroceryPortal;
